import { type CSSProperties } from 'react'
import { cx } from 'utils/cx'

import { ProgressBar } from '../ProgressBar'
import { useStepperTiers } from './hooks/useStepperTiers'
import type { StepperTiersProps } from './types/types'

import styles from './StepperTiers.module.scss'
import texts from 'fukku/styles/texts.module.scss'

export const StepperTiers = ({
	steps,
	value,
	max,
	...rest
}: StepperTiersProps) => {
	const { normalizedValue, currentStep, stepWidth, stepsContainerRef } =
		useStepperTiers({
			value,
			steps,
			max,
		})

	return (
		<div className={styles.container}>
			<ProgressBar max={max} value={normalizedValue} {...rest} />
			<div ref={stepsContainerRef} className={styles.steps}>
				{steps.map(({ text, threshold }, index) => {
					if (!stepWidth) {
						return null
					}

					const isInCurrentStep = currentStep === index

					return (
						<span
							style={
								{
									maxWidth: `${stepWidth}px`,
								} as CSSProperties
							}
							className={cx(
								texts.uppercaseS,
								styles.step,
								!isInCurrentStep && styles.notCurrentStep
							)}
							key={`stepperTiers.${text}.${threshold}`}
						>
							{text}
						</span>
					)
				})}
			</div>
		</div>
	)
}
